import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "../api/baseurl";
import { toast } from "react-toastify";
import "./Spinner.css";
import "react-toastify/dist/ReactToastify.css";
import { Modal } from "react-bootstrap";
import "./hm-theme.css";

const CreateLabCorporate = ({ isOpen, onRequestClose }) => {
  const navigate = useNavigate();

  const url = "/api/createAccount";
  const [labCorporateDetails, setLabCorporateDetails] = useState({
    username: "",
    role: "ROLE_LAB_CORPORATE",
    name: "",
    orgcode: "",
    email: "",
    contact: "",
    pan: "",
    gstin: "",
    tan: "",
    clientId: "",
    address: "",
    city: "",
    pincode: "",
    state: "",
    labCorporate: {
      email: "",
      name: "",
      orgcode: "",
      contact: "",
      pan: "",
      gstin: "",
      tan: "",
      address: "",
      city: "",
      pincode: "",
      state: "",
      clientId: "",
      sendNotification: false,
      labCorporateProfileImage: {
        image: null,
        imageMeta: "",
      },
    },
  });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const token = JSON.parse(localStorage.getItem("data")).token;
    try {
      const emailCheckResponse = await axios.get(
        `/api/accounts/getByEmail=${labCorporateDetails.email}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (emailCheckResponse.data) {
        toast.error("Email already exists.");
        setLoading(false);
        return;
      }
    } catch (error) {
      handleError(error);
      setLoading(false);
      return;
    }
    axios
      .post(
        url,
        {
          username: labCorporateDetails.email,
          role: "ROLE_LAB_CORPORATE",
          labCorporate: {
            email: labCorporateDetails.email,
            name: labCorporateDetails.name,
            orgcode: labCorporateDetails.orgcode,
            contact: labCorporateDetails.contact,
            pan: labCorporateDetails.pan,
            gstin: labCorporateDetails.gstin,
            tan: labCorporateDetails.tan,
            address: labCorporateDetails.address,
            city: labCorporateDetails.city,
            pincode: labCorporateDetails.pincode,
            state: labCorporateDetails.state,
            clientId: labCorporateDetails.clientId,
            sendNotification: labCorporateDetails.labCorporate.sendNotification,
            labCorporateProfileImage: labCorporateDetails.labCorporate.labCorporateProfileImage,
          },
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then((res) => {
        setLoading(false);
        onRequestClose();
        setLabCorporateDetails({
          username: "",
          role: "ROLE_LAB_CORPORATE",
          name: "",
          orgcode: "",
          email: "",
          contact: "",
          pan: "",
          gstin: "",
          tan: "",
          clientId: "",
          address: "",
          city: "",
          pincode: "",
          state: "",
          labCorporate: {
            email: "",
            name: "",
            orgcode: "",
            contact: "",
            pan: "",
            gstin: "",
            tan: "",
            address: "",
            city: "",
            pincode: "",
            state: "",
            clientId: "",
            sendNotification: false,
            labCorporateProfileImage: {
              image: null,
              imageMeta: "",
            },
          },
        });
        toast.success("Lab Corporate account created successfully and Password sent to their email");
      })
      .catch((error) => {
        setLoading(false);
        handleError(error);
      });
  };

  function handleError(error) {
    if (error.response) {
      if (error.response.status === 401) {
        navigate(`/signin`);
        toast.error("Your session has expired. Please login.");
      } else if (error.response.data && error.response.data.message) {
        toast.error(error.response.data.message);
      } else if (error.response.data && error.response.data.code) {
        toast.error(error.response.data.code);
      } else {
        toast.error("An error occurred.");
      }
    } else if (error.message) {
      toast.error(error.message);
    } else {
      toast.error("An error occurred.");
    }
  }

  function rhandle(e) {
    const { id, value } = e.target;
    setLabCorporateDetails((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  }

  const handleSendNotificationChange = (e) => {
    const { checked } = e.target;
    setLabCorporateDetails((prevState) => ({
      ...prevState,
      labCorporate: {
        ...prevState.labCorporate,
        sendNotification: checked,
      },
    }));
  };

  return (
    <Modal show={isOpen} onHide={onRequestClose} centered size="lg">
      <Modal.Header closeButton className="hm-card-header">
        <Modal.Title className="hm-card-title">
          <i className="material-icons">business</i>
          Add Lab Corporate Details
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-4">
        {loading && <div className="loading"></div>}
        <form onSubmit={handleSubmit}>
          {/* General Information Section */}
          <div className="mb-4">
            <h6 className="fw-bold mb-3 d-flex align-items-center gap-2" style={{ color: "#2f3a88" }}>
              <i className="material-icons" style={{ fontSize: "1.1rem" }}>badge</i>
              General Information
            </h6>
            <div className="row g-3">
              <div className="col-md-6">
                <label htmlFor="name" className="form-label small fw-semibold">
                  Name <span className="text-danger">*</span>
                </label>
                <input
                  className="form-control"
                  id="name"
                  type="text"
                  placeholder="Enter Name"
                  value={labCorporateDetails.name || ""}
                  onChange={rhandle}
                  required
                />
              </div>

              <div className="col-md-6">
                <label htmlFor="orgcode" className="form-label small fw-semibold">
                  Orgcode <span className="text-danger">*</span>
                </label>
                <input
                  className="form-control"
                  id="orgcode"
                  type="text"
                  placeholder="Enter Orgcode"
                  value={labCorporateDetails.orgcode || ""}
                  onChange={rhandle}
                  required
                />
              </div>

              <div className="col-md-6">
                <label htmlFor="email" className="form-label small fw-semibold">
                  Email <span className="text-danger">*</span>
                </label>
                <input
                  className="form-control"
                  id="email"
                  type="email"
                  placeholder="Enter Email"
                  value={labCorporateDetails.email || ""}
                  onChange={rhandle}
                  required
                />
              </div>

              <div className="col-md-6">
                <label htmlFor="contact" className="form-label small fw-semibold">
                  Contact Number <span className="text-danger">*</span>
                </label>
                <input
                  className="form-control"
                  id="contact"
                  type="text"
                  placeholder="Enter Contact Number"
                  value={labCorporateDetails.contact || ""}
                  onChange={rhandle}
                  required
                />
              </div>
            </div>
          </div>

          {/* Identifiers Section */}
          <div className="mb-4 pt-3 border-top">
            <h6 className="fw-bold mb-3 d-flex align-items-center gap-2" style={{ color: "#2f3a88" }}>
              <i className="material-icons" style={{ fontSize: "1.1rem" }}>receipt_long</i>
              Registration & Tax Identifiers
            </h6>
            <div className="row g-3">
              <div className="col-md-4">
                <label htmlFor="gstin" className="form-label small fw-semibold">
                  GSTIN <span className="text-danger">*</span>
                </label>
                <input
                  className="form-control"
                  id="gstin"
                  type="text"
                  placeholder="GSTIN"
                  value={labCorporateDetails.gstin || ""}
                  onChange={rhandle}
                  required
                />
              </div>

              <div className="col-md-4">
                <label htmlFor="pan" className="form-label small fw-semibold">
                  PAN
                </label>
                <input
                  className="form-control"
                  id="pan"
                  type="text"
                  placeholder="PAN"
                  value={labCorporateDetails.pan || ""}
                  onChange={rhandle}
                />
              </div>

              <div className="col-md-4">
                <label htmlFor="tan" className="form-label small fw-semibold">
                  TAN
                </label>
                <input
                  className="form-control"
                  id="tan"
                  type="text"
                  placeholder="TAN"
                  value={labCorporateDetails.tan || ""}
                  onChange={rhandle}
                />
              </div>

              <div className="col-md-6">
                <label htmlFor="clientId" className="form-label small fw-semibold">
                  Client Code <span className="text-danger">*</span>
                </label>
                <input
                  className="form-control"
                  id="clientId"
                  type="text"
                  placeholder="Client Code"
                  value={labCorporateDetails.clientId || ""}
                  onChange={rhandle}
                  required
                />
              </div>
            </div>
          </div>

          {/* Address Section */}
          <div className="mb-4 pt-3 border-top">
            <h6 className="fw-bold mb-3 d-flex align-items-center gap-2" style={{ color: "#2f3a88" }}>
              <i className="material-icons" style={{ fontSize: "1.1rem" }}>location_on</i>
              Lab Corporate Address
            </h6>
            <div className="row g-3">
              <div className="col-12">
                <label htmlFor="address" className="form-label small fw-semibold">
                  Address <span className="text-danger">*</span>
                </label>
                <textarea
                  className="form-control"
                  id="address"
                  rows="2"
                  placeholder="Address"
                  value={labCorporateDetails.address || ""}
                  onChange={rhandle}
                  required
                />
              </div>

              <div className="col-md-4">
                <label htmlFor="city" className="form-label small fw-semibold">
                  City <span className="text-danger">*</span>
                </label>
                <input
                  className="form-control"
                  id="city"
                  type="text"
                  placeholder="City"
                  value={labCorporateDetails.city || ""}
                  onChange={rhandle}
                  required
                />
              </div>

              <div className="col-md-4">
                <label htmlFor="pincode" className="form-label small fw-semibold">
                  Pincode <span className="text-danger">*</span>
                </label>
                <input
                  className="form-control"
                  id="pincode"
                  type="text"
                  placeholder="Pincode"
                  value={labCorporateDetails.pincode || ""}
                  onChange={rhandle}
                  required
                />
              </div>

              <div className="col-md-4">
                <label htmlFor="state" className="form-label small fw-semibold">
                  State <span className="text-danger">*</span>
                </label>
                <input
                  className="form-control"
                  id="state"
                  type="text"
                  placeholder="State"
                  value={labCorporateDetails.state || ""}
                  onChange={rhandle}
                  required
                />
              </div>
            </div>
          </div>

          {/* Notification Checkbox & Actions */}
          <div className="d-flex align-items-center justify-content-between pt-3 border-top">
            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                id="sendNotification"
                checked={labCorporateDetails.labCorporate?.sendNotification || false}
                onChange={handleSendNotificationChange}
              />
              <label className="form-check-label small fw-semibold" htmlFor="sendNotification">
                Send Notification
              </label>
            </div>

            <div className="d-flex align-items-center gap-2">
              <button
                type="button"
                className="btn btn-outline-secondary rounded-pill px-4"
                onClick={onRequestClose}
              >
                Close
              </button>
              <button type="submit" className="btn-hm-primary px-4" disabled={loading}>
                {loading ? "Saving..." : "Save Corporate"}
              </button>
            </div>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

export default CreateLabCorporate;

